import { Link } from 'react-router';
import { PortalLayout } from './PortalLayout';

/** Unbekannter Pfad (z. B. veralteter Link). */
export function NotFoundPage() {
  return (
    <PortalLayout>
      <section>
        <h1>Seite nicht gefunden</h1>
        <p className="lead">Diese Adresse gibt es nicht (mehr).</p>
        <p>
          <Link to="/">Zur Startseite</Link>
        </p>
      </section>
    </PortalLayout>
  );
}
